import request from '@/utils/request'


export function getLoginHistory(param, isNotify) {
  return request({
    url: `/api/getLoginHistory`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    data:param,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}